<template>
  <md-dialog
    id="modDashboardComponents"
    ref="stepperModal"
    md-title
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="stepper-modal modals"
  >
    <v-stepper
      v-if="!isLoading"
      v-model="currentStep"
    >
      <v-card>
        <md-dialog-title>
          <v-stepper-header>
            <h2>Confirmação de OS's</h2>
            <v-stepper-step
              v-for="(order, index) in duplicatedOrdersFromXml"
              :key="index"
              :complete="currentStep > (index + 1)"
              color="#7F1A54"
              :step="index + 1"
            />
          </v-stepper-header>
        </md-dialog-title>
        <hr>
      </v-card>
      <v-stepper-items>
        <v-stepper-content
          v-for="(order, index) in duplicatedOrdersFromXml"
          :key="index"
          :step="index + 1"
        >
          <v-card>
            <div class="container-content">
              <p class="main-paragraph additional-spacing">
                Encontramos
                <span class="highlight">{{ duplicatedOrdersFromXml.length }}</span>
                <span
                  v-if="duplicatedOrdersFromXml.length > 1"
                >Ordens de serviço já importadas ou cadastradas anteriormente:</span>
                <span v-else>Ordem de serviço já importada ou cadastrada anteriormente:</span>
              </p>

              <p class="main-paragraph">
                OS
                <span
                  class="highlight"
                  @click="thereAreIncorrectExams(order)"
                >{{ order.code_lis }}</span>
              </p>

              <div
                v-if="true"
                class="container-exams"
              >
                <p class="paragraph-small">
                  importado:
                  <span v-if="order.exams.length > 0">exame</span>
                  <span
                    v-for="(exam, index) in filterExamsOld(order.exams)"
                    :key="'exam-old-' + index"
                  >
                    <template v-if="!exam.added_xml_exam">
                      {{ exam.code }}<span v-if="(index + 1) < filterExamsOld(order.exams).length">,</span>
                    </template>
                  </span>
                </p>
                <p
                  v-if="filterExamsNew(order.exams).length > 0"
                  class="paragraph-medium"
                >
                  novo:
                  <span v-if="order.exams.length > 0">exame</span>
                  <span
                    v-for="(exam, index) in filterExamsNew(order.exams)"
                    :key="'exam-new-' + index"
                  >
                    <template v-if="exam.added_xml_exam">
                      {{ exam.code }}<span v-if="(index + 1) < filterExamsNew(order.exams).length">,</span>
                    </template>
                  </span>
                </p>
                <p
                  v-if="filterExamsIncorrect(order.exams).length > 0"
                  class="paragraph-medium incorrect"
                >
                  incorreto:
                  <span v-if="order.exams.length > 0">exame</span>
                  <span
                    v-for="(exam, index) in filterExamsIncorrect(order.exams)"
                    :key="'exam-incorrect-' + index"
                  >
                    <template v-if="exam.added_xml_exam">
                      {{ exam.code }}<span v-if="(index + 1) < filterExamsIncorrect(order.exams).length">,</span>
                    </template>
                  </span>
                </p>
              </div>
            </div>
          </v-card>
          <div
            v-if="isImpossibleToMerge(order)"
            class="container-actions"
          >
            <h2>Não é possível incluir o exame nesta OS, {{ reasonToNotMerge }}</h2>
            <div class="buttons">
              <md-button
                class="btn btn-primary batch-modal-details__button"
                @click="order.state !== ORDER_STATE_TRANSMITTED ? nextStep(currentStep) : deleteDuplicatedOrder(order, currentStep)"
              >
                Ok
              </md-button>
            </div>
          </div>
          <div
            v-else-if="uploadMaintenanceStatus === 'STATUS_INITIAL'"
            class="container-actions"
          >
            <h2>Deseja adicionar os novos exames à OS existente?</h2>
            <div class="buttons">
              <md-button
                class="btn btn-nonenary batch-modal-details__button"
                @click="deleteDuplicatedOrder(order, currentStep)"
              >
                NÃO
              </md-button>
              <md-button
                class="btn btn-primary batch-modal-details__button"
                @click="updateDuplicatedOrder(order, currentStep)"
              >
                SIM
              </md-button>
            </div>
          </div>
          <div
            v-else-if="uploadMaintenanceStatus === 'STATUS_UPLOADING'"
            class="container-loading"
          >
            <loading />
            <h2>Salvando alterações...</h2>
          </div>
          <div
            v-else-if="uploadMaintenanceStatus === 'STATUS_FAILED'"
            class="container-error"
          >
            <div class="message">
              <h2>{{ errorMessage }}</h2>
              <md-tooltip>{{ errorMessage }}</md-tooltip>
            </div>
            <div class="buttons">
              <md-button
                class="btn btn-primary batch-modal-details__button"
                @click="nextStep(currentStep)"
              >
                Ok
              </md-button>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div
      v-else
      class="container-spinner"
    >
      <spinner />
      <p>Carregando as informações</p>
    </div>
  </md-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Spinner from '../common/Spinner'
import {ORDER_STATUS_ERROR, ORDER_STATE_TRANSMITTED} from '@/enums'

let defaultError = 'Não foi possível salvar esta operação.'
let reasonIncorrect = 'pois ele está incorreto.'
let reasonFeatureToggle = 'pois ele já foi transferido.'

export default {
  name: 'StepperModal',
  components: {
    spinner: Spinner
  },
  data: () => ({
    currentStep: 0,
    ORDER_STATE_TRANSMITTED: ORDER_STATE_TRANSMITTED,
    isLoading: true,
    errorMessage: defaultError,
    reasonToNotMerge: reasonIncorrect
  }),
  computed: {
    ...mapGetters(['isStepperModalVisible', 'duplicatedOrdersFromXml', 'uploadMaintenanceMessage', 'uploadMaintenanceStatus', 'toggle'])
  },
  watch: {
    isStepperModalVisible () {
      if (this.isStepperModalVisible) {
        this.$refs.stepperModal.open()
      } else {
        this.$refs.stepperModal.close()
        this.reload()
        this.clearAll()
      }
    },
    duplicatedOrdersFromXml (newValue) {
      if (newValue.length > 0) {
        this.isLoading = false
      } else {
        this.isLoading = true
      }
    },
    uploadMaintenanceStatus (newValue) {
      if (newValue === 'STATUS_SUCCESS') {
        this.nextStep(this.currentStep)
      } else if (newValue === 'STATUS_FAILED') {
        this.errorMessage = this.uploadMaintenanceMessage
      }
    }
  },
  methods: {
    ...mapActions(['setStepperModalVisible', 'updateOsXml', 'deleteOsXML', 'clearDuplicatedOrdersArray', 'clearAllOrderData', 'setInitialMaintenanceStatus']),
    openMaintenanceModal () {
      this.setStepperModalVisible(true)
    },
    closeMaintenanceModal () {
      this.setStepperModalVisible(false)
    },
    updateDuplicatedOrder (order) {
      this.updateOsXml(order)
    },
    deleteDuplicatedOrder (order) {
      this.deleteOsXML(order)
    },
    nextStep (step) {
      this.setInitialMaintenanceStatus()
      if (this.isLastStep(step)) {
        this.closeMaintenanceModal()
      } else {
        this.currentStep++
      }
    },
    isLastStep (step) {
      return step === this.duplicatedOrdersFromXml.length
    },
    clearAll () {
      this.currentStep = 0
      this.isLoading = true
      this.clearDuplicatedOrdersArray()
    },
    reload () {
      if (this.$router.history.current.path === '/orders') {
        this.clearAllOrderData()
      }
    },
    filterExamsOld (exams) {
      return exams.reduce(function (filteredExams, elem) {
        if (!elem.added_xml_exam) {
          filteredExams.push(elem)
        }
        return filteredExams
      }, [])
    },
    filterExamsNew (exams) {
      return exams.reduce(function (filteredExams, elem) {
        if (elem.added_xml_exam && elem.status !== ORDER_STATUS_ERROR) {
          filteredExams.push(elem)
        }
        return filteredExams
      }, [])
    },
    filterExamsIncorrect (exams) {
      return exams.reduce(function (filteredExams, elem) {
        if (elem.added_xml_exam && elem.status === ORDER_STATUS_ERROR) {
          filteredExams.push(elem)
        }
        return filteredExams
      }, [])
    },
    isImpossibleToMerge (order) {
      if (order.state !== 'T') {
        this.reasonToNotMerge = reasonIncorrect
        return (
          this.filterExamsIncorrect(order.exams).length > 0 &&
          this.filterExamsNew(order.exams).length === 0
        )
      } else {
        if (!this.toggle.mergeAfterTransferred) {
          this.reasonToNotMerge = reasonFeatureToggle
          return true
        } else {
          this.reasonToNotMerge = reasonIncorrect
          return this.filterExamsIncorrect(order.exams).length > 0
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";
@import "../../../static/stylesheets/stepper";

.stepper-modal {
  &.modals .md-dialog {
    width: 700px;
    height: auto;

    .md-dialog-title {
      padding: 24px 24px 0;
    }

    .v-stepper__header {
      h2 {
        margin: auto 0;
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        line-height: 26px;
        font-size: 26px;
        color: $brand-primary;
        margin-right: auto;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /* IE10 & IE11 CSS styles go here */
          display: flex;
          align-items: center;
        }
      }
    }

    .v-stepper__step {
      padding: 5px;
      font-weight: 500;

      &--complete {
        span {
          background-color: #55cd9e !important;
          border-color: #55cd9e !important;
        }
      }
    }

    hr {
      border: 1px solid #b8b7bf;
    }

    .container {
      text-align: center;

      &-loading {
        padding-bottom: 26px;

        h2 {
          padding-top: 10px;
          font-size: 18px;
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 300;
          line-height: 26px;
          text-align: center;
          color: #4a4a4a;
        }
      }

      &-content {
        padding: 10px 20px;

        .main-paragraph {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 300;
          line-height: 26px;
          font-size: 22px;
          text-align: center;
          color: #4a4a4a;

          .highlight {
            font-weight: 400;
            color: $brand-primary;
          }
        }
        .additional-spacing {
          padding-bottom: 25px;
        }
      }

      &-error {
        padding-bottom: 26px;
        padding-left: 10px;
        padding-right: 10px;

        .message {
          max-height: 5em;
          overflow: hidden;
          margin-bottom: 26px;
        }

        h2 {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          font-size: 18px;
          text-align: center;
          color: #b63642;
        }

        .buttons {
          justify-content: center;
          display: flex;
        }

        .md-button {
          min-width: 190px;
          margin-right: 1em;
          margin-left: 1em;
        }
      }

      &-exams {
        text-align: center;
        padding-top: 15px;
        padding-bottom: 20px;
        p {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: normal;
          line-height: 26px;
        }

        span {
          font-weight: 300;
        }
      }

      &-actions {
        padding-bottom: 26px;

        h2 {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 300;
          line-height: 22px;
          font-size: 20px;
          text-align: center;
          color: #4a4a4a;
          padding-bottom: 26px;
        }

        .buttons {
          justify-content: center;
          display: flex;
        }

        .md-button {
          min-width: 190px;
          margin-right: 1em;
          margin-left: 1em;
        }
      }

      &-spinner {
        margin: auto;
        padding: 8em;

        p {
          padding-top: 2em;
        }
      }
    }

    .paragraph {
      &-small {
        font-size: 16px;
        color: #4a4a4a;
      }

      &-medium {
        color: $brand-primary;
        font-size: 20px;
      }

      &-large {
        font-size: 23px;
      }
    }

    .incorrect {
      color: red;
    }

    .v-stepper__header {
      max-height: 3em;
      overflow-y: auto;
    }

    .v-stepper,
    .v-card,
    .v-stepper,
    .v-stepper__header {
      box-shadow: none;
    }
  }
}
</style>
